module.exports = __webpack_public_path__ + "img/image2.da0e38cf.png";